// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__14dCJ","tab":"ProcedureTabs_tab__13cVE"};